import React from "react";
import * as Yup from "yup";
import BaseForm from "./BaseForm";
import FieldInputText from "components/FieldInputText";

const FormDetails = () => {
  const schema = Yup.object().shape({
    name: Yup.string().required().label("Name"),
  })
  
    return (
      <BaseForm
        schema={schema}
        render={(methods: any) => (
          <>
            <FieldInputText 
                name="name" 
                control={methods.control} 
                label="Project Name" 
            />
            <FieldInputText
              name="description"
              label="Description"
              multiline
              rows={3}
              control={methods.control}
              //height={150}
            />
          </>
        )}
      />
    );
  }
  
  export default FormDetails;